// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../index';

export const MetalFilterMetalFragmentDoc = `
    fragment metalFilterMetal on Metal {
  systemCode
  translation(locale: $locale) {
    name
  }
  karat
  color {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  element {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
}
    `;
export const MetalFilterFragmentDoc = `
    fragment metalFilter on CatalogueFilterMetalItem {
  metal {
    ...metalFilterMetal
  }
  totalResults
}
    `;